import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RealEstateCreatePage } from './realestate-create.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'realestate/create',
    component: RealEstateCreatePage,
    canActivate: [authGuard, hasRoleGuard(null, ['create_realestate'])],
    data: {
      title: "Nueva propiedad"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RealEstateCreatePageRoutingModule { }
